import React from "react";
import PlansRadio from "../../../kit-components/Radio/Plans"
import Skeleton from 'react-loading-skeleton';
import styles from './offers.module.scss';


export function Item(props) {
    const { data, handleClick, pastOffer, index } = props;
  
    return (
      <div className={styles['container']}>
        <input
          className={styles['radio-input']}
          type="radio"
          id={data.id.toString()}
          name="offers"
          value={data.id}
          onClick={() => handleClick(data)}
          checked={pastOffer=== data.id}
        />
        <label
          className={styles['radio-input-lable']}
          htmlFor={data.id.toString()}
        >
          <div className={styles['radio-input-content']}>
            <span className={styles['radio-input-lable-text']}>
              {data.title}
            </span>

          </div>
        </label>
      </div>
    );
  }
export function Offers(props) {
  const { offers, updateOffer, pastOffer } = props;

  return (
    <div className={styles['form']}>
      {offers.length === 0 ? (
        <div className={styles['plans-skelton']}>
          {[1, 2, 3, 4].map(() => {
            return (
              <div className={styles['item']}>
                <Skeleton height={65} />
              </div>
            );
          })}
        </div>
      ) : (
       <div>
        <h2 className={styles['section-title']}>Available Offers</h2>
        <div className={styles['radio-form']}>
                {offers.map((offer, index) => {
                    return (
                        <Item
                            data={offer}
                            handleClick={updateOffer}
                            key={offer.id}
                            index={index}
                            pastOffer={pastOffer}
                        />
                    );
                }
                )}
        </div>
       </div>
      )}
    </div>
  );
}

export default Offers;
